import React from 'react'
import Login from "../pages/login/index"
import Password from "../pages/password/index"
import Demo from "../components/demo"
import { BrowserRouter as Router, Route} from "react-router-dom";

function BasicRouter() {
    return (
        <Router>
            <Route path="/" component={Login} exact />
            <Route path='/Login' component={Login}></Route>
            <Route path='/Password' component={Password}></Route>
            <Route path='/Demo' component={Demo}></Route>
        </Router>
    )
}

export default BasicRouter;
